export const _initialState = {
  configurator: {
    choices: null,
    options: null,
    metadata: null,
    itemIds: null,
    choiceMetadata: null,
  },
  mobile: {
    selectedOption: null,
    selectedOptionLabel: null
  },
  drawer: { isOpen: false, bundleId: null },
};
